exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-balance-use-detail .step-group-item .time[data-v-17450ee3]{font-size:.32rem;background-color:#f6f6f6;color:#aeaeae;border-radius:.266667rem;padding:.053333rem .4rem}.user-balance-use-detail .step-group-item .title[data-v-17450ee3]{font-size:.373333rem!important;margin:.4rem 0 .266667rem 0;color:#333}.user-balance-use-detail .step-group-item .text[data-v-17450ee3]{font-size:.373333rem;word-break:break-all;color:#aeaeae;line-height:.533333rem;margin-bottom:.8rem}.user-balance-use-detail[data-v-17450ee3] .van-step__circle{width:.266667rem!important;height:.266667rem!important}", ""]);

// exports
